import {
  contactTypeOption,
  countries, degreeTypeOption, entityNumberTypeOption,
  entityRoleOption, issuerLocationTypeOption,
  lotNumberQualifierOption,
  processingCodeOption,
  programCodeOption,
  sourceTypeOption,
  temperatureQualifierOption, usStates
} from "./options";

const pgaFdaHeader = [
  {
    name: 'programCode',
    label: 'Program Code',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'processingCode',
    label: 'Processing Code',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'intendedUseCode',
    label: 'Intended Use Code',
    type: 'text',
    maxLength: 16,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'intendedUseDescription',
    label: 'Intended Use Description',
    type: 'text',
    maxLength: 21,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'productNumber',
    label: 'Product Number',
    type: 'text',
    maxLength: 19,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'tradeNameBrandName',
    label: 'Trade Name/Brand Name',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'productDescription',
    label: 'Product Description',
    type: 'text',
    maxLength: 57,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
    sizeProp: { xs: 12, sm: 12, lg: 6, xl: 6 }
  },
  {
    name: 'arrivalDateTime',
    label: 'Arrival Date Time',
    type: 'datetime',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'portOfArrival',
    label: 'Port of Arrival',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'firmsCode',
    label: 'FIRMS Code',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  },
  {
    name: 'pnConfirmationNumber',
    label: 'PN Confirmation Number',
    type: 'text',
    maxLength: 33,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaHeader',
  }
]

const fdaCountryOrigin = [
  {
    name: 'country',
    label: 'Country',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'sourceType',
    label: 'Source Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaPackaging = [
  {
    name: 'qualifier',
    label: 'Qualifier',
    type: 'number',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'quantity',
    label: 'Quantity',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'unit',
    label: 'Unit',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaAffirmationCompliance = [
  {
    name: 'complianceCode',
    label: 'Compliance Code',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'complianceDesc',
    label: 'Compliance Description',
    type: 'text',
    maxLength: 30,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaLotInformation = [
  {
    name: 'lotNumberQualifier',
    label: 'Lot Number Qualifier',
    type: 'auto',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'lotNumber',
    label: 'Lot Number',
    type: 'text',
    maxLength: 25,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'pgaLineValue',
    label: 'PGA Line Value',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'temperatureQualifier',
    label: 'Temperature Qualifier',
    type: 'auto',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaLotInformationDRU = [
  {
    name: 'productionDateStart',
    label: 'Production Date Start',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'productionDateEnd',
    label: 'Production Date End',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'temperature',
    label: 'Temperature',
    type: 'number',
    maxLength: 6,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'degreeType',
    label: 'Degree Type',
    type: 'auto',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'tempRecordingLocation',
    label: 'Temp Recording Location',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaPartiesPointContact = [
  {
    name: 'saveTradePartner',
    label: 'Save party to Trade Partner',
    type: 'checkbox',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    name: 'partyMasterName',
    label: 'Profile Name',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
    requiredCondition: (formData, sectionData) => sectionData?.saveTradePartner === true,
  },
    {
    name: 'partyLookup',
    label: 'Party Lookup',
    type: 'lookupButton',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true,
  },
  {
    type: 'new',
    ignoreColumn: true,
  },
  {
    name: 'entityRole',
    label: 'Entity Role',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'entityName',
    label: 'Entity Name',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'entityNumber',
    label: 'Entity Number',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'entityNumberType',
    label: 'Entity Number Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'entityAddress1',
    label: 'Entity Address 1',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'entityAddress2',
    label: 'Entity Address 2',
    type: 'text',
    maxLength: 32,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'apartmentSuiteNumber',
    label: 'Apartment/Suite Number',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    maxLength: 21,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'stateProvince',
    label: 'State/Province',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'postalCode',
    label: 'Postal Code',
    type: 'text',
    maxLength: 9,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'country',
    label: 'Country',
    type: 'auto',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'contactType',
    label: 'Contact Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'contactName',
    label: 'Contact Name',
    type: 'text',
    maxLength: 23,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'contactTelephone',
    label: 'Contact Telephone',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  },
  {
    name: 'contactEmail',
    label: 'Contact Email',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    ignoreColumn: true
  }
]

const fdaLACF = [
  {
    name: 'canDimensions1',
    label: 'Can Dimensions #1',
    type: 'number',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaLACF'
  },
  {
    name: 'canDimensions2',
    label: 'Can Dimensions #2',
    type: 'number',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaLACF'
  },
  {
    name: 'canDimensions3',
    label: 'Can Dimensions #3',
    type: 'number',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaLACF'
  },
  {
    name: 'packageTrackingNumber',
    label: 'Package Tracking Number',
    type: 'text',
    maxLength: 50,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaLACF'
  },
  {
    name: 'carrierScacIata',
    label: "Carrier/Courier's SCAC/IATA",
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaLACF'
  }
]

const fdaPrivateOwnedVehicleInformation = [
  {
    name: 'vehicleLicensePlateNumber',
    label: 'Vehicle License Plate Number',
    type: 'text',
    maxLength: 33,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaVehicle'
  },

  {
    name: 'issuerName',
    label: 'Issuer Name',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaVehicle'
  },
  {
    name: 'issuerLocationType',
    label: 'Issuer Location Type',
    type: 'auto',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaVehicle'
  },
  {
    name: 'issuerLocationCode',
    label: 'Issuer Location Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaVehicle'
  },
  {
    name: 'issuerLocationName',
    label: 'Issuer Location Name',
    type: 'text',
    maxLength: 25,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaVehicle'
  }
]

const fdaConstituent = [
  {
    name: 'constituentName',
    label: 'Name',
    type: 'text',
    maxLength: 51,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'constituentQuantity',
    label: 'Quantity',
    type: 'number',
    maxLength: 12,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'constituentUnit',
    label: 'Unit',
    type: 'text',
    maxLength: 5,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'percent',
    label: 'Percent',
    type: 'number',
    maxLength: 7,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'isActiveRemarks',
    label: 'Is Active',
    type: 'text',
    maxLength: 1,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaContainer = [
  {
    name: 'containerNum',
    label: 'Container Number',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
]

const fdaRemark = [
  {
    name: 'remarks',
    label: 'Remarks',
    type: 'text',
    maxLength: 68,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    section: 'fdaRemarks'
  }
]

const countryOriginOptionsMap = {
  country: countries,
  sourceType: sourceTypeOption
}

const lotInfoOptionsMap = {
  lotNumberQualifier: lotNumberQualifierOption,
  temperatureQualifier: temperatureQualifierOption,
  degreeType: degreeTypeOption
}

const partiesOptionsMap = {
  entityRole: entityRoleOption,
  entityNumberType: entityNumberTypeOption,
  stateProvince: usStates,
  country: countries,
  contactType: contactTypeOption,
  partyLookup: [], // Will be populated dynamically
}

export {
  pgaFdaHeader,
  fdaRemark,
  fdaContainer,
  fdaConstituent,
  fdaPrivateOwnedVehicleInformation,
  fdaLACF,
  fdaCountryOrigin,
  fdaPackaging,
  fdaAffirmationCompliance,
  fdaLotInformation,
  fdaLotInformationDRU,
  fdaPartiesPointContact,
  countryOriginOptionsMap,
  lotInfoOptionsMap,
  partiesOptionsMap
}